import { Component, Input } from '@angular/core';
import { NavController, IonInfiniteScroll, LoadingController } from '@ionic/angular';
import { EventProvider, EventComplex, EventDetailsModel, EventTievts, EventSearchModel, Pager } from '../../providers/event/event';
import { ResultProvider } from '../../providers/result/result';
import { LoaderProvider } from '../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { Route, Router } from '@angular/router';

/**
 * Generated class for the ImageContainerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
    selector: 'menu-layer-total',
    templateUrl: 'menu-layer-total.html',
    styleUrls:['./menu-layer-total.scss']
})
export class MenuLayerTotalComponent {
    currentPage = 1;
    EVENTS_PER_PAGE = 10;

    @Input("eventType")
    eventType: string = "";

    @Input("eventArea")
    eventArea: string = "";

    @Input("type")
    type: string = "Events";

    events = [];

    searchModel: EventSearchModel = {
        cid: -1,
        dur: '',
        str: '',
        umkr: '',
        zip: -1,
        searchQuery:""
    };

    savedSearch: Pager;

    constructor(public navCtrl: NavController,
        public eventService: EventProvider,
        public resultService: ResultProvider,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        private route:Router
    ) {
    }

    getEventStatus(event: EventTievts) {
        if (typeof event === "undefined") return "";
        let status = event.eventStatus;
        if (status.toUpperCase().includes("C")) return this.translate.instant('EVENT_CANCELLED');
        else if (status.toUpperCase().includes("N")) return this.translate.instant('NOT_CONFIRMED');
        else return "";
    }

    async ngAfterViewInit() {
        var loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.searchModel.limit = 10 + '';
        this.searchModel.page = 1 + '';
        this.searchModel.start = 1 + '';
        let type = this.resultService.getResultTypeAPIName(this.eventType, this.type);
        this.eventService.getEventSimple(type, this.eventArea, this.searchModel).then(events => {
            let unique = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);

            if (this.eventArea.toUpperCase().includes("VIR")) this.eventArea = this.translate.instant("CATEGORY_VIRTUAL");
            this.events = Object.assign([], unique);

            this.savedSearch = {
                page: this.searchModel.page,
                limit: this.searchModel.limit,
                start: this.searchModel.start
            };

            this.loadNextPage(null);

            loader.dismiss();
        });
    }

    arrayOf(n?: number) {
        return this.events.slice(0, this.EVENTS_PER_PAGE * this.currentPage);
    }

    // loadNextPage(event: InfiniteScroll) {
    //     this.currentPage++;
    //     event.complete();
    // }

    onEventLoad(event) {
        if (this.type === "Events") this.openEventDetails(event);
        else this.onShowRangList(event);
    }

    async openEventDetails(_event) {
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventService.getEventId(_event.eventName, _event.ort, _event.dateFormatted, _event.cid).then(id => {
            if (id == -1) { loader.dismiss(); return; };

            this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {

                if (event.name.length < 1) {
                    this.openEventDetails(_event);
                    loader.dismiss();
                } else {
                    this.navCtrl.navigateForward('/event/details/tabs', {state:{event: event}}).then(() => loader.dismiss());
                    // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        })
    }

    loadNextPage(paginator) {
        this.searchModel.limit = (Number(this.searchModel.limit) + 10) + '';

        this.eventService.getEventSimple(this.resultService.getResultTypeAPIName(this.eventType, this.type), this.eventArea, this.searchModel).then(events => {
            let unique = events.filter((v, i, a) => a.findIndex(t => (t.eventName === v.eventName)) === i);
            this.events = unique;
            if (paginator) paginator.complete();
        });
    }


    async onShowRangList(event) {
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.eventService.getEventId(event.eventName, event.ort, event.dateFormatted, event.cid).then(id => {

            let searchModel = { eid: '' + id, ename: '' + event.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };

            this.navCtrl.navigateForward('/result-event-details', {state:{eventDetails: event, search: searchModel }})
            // (this.app.getRootNav() as NavController).push(ResultEventDetailsPage, { eventDetails: event, search: searchModel })
                .then(() => loader.dismiss());
        });
    }
}
